import { Injectable } from '@angular/core';
import { Menus } from '@layout-lib';
import { EnvironmentService } from '@methylium/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { appMenus } from '../environments/environment';

@Injectable()
export class MenuVisibilityService {
  constructor(
    private readonly environmentService: EnvironmentService,
    private readonly oidcService: OidcSecurityService
  ) {}

  // This is a first implementation. We should decide how we can improve this.
  getMenus(): Menus {
    const isSecurityEnabled = this.environmentService.environment.features?.security?.enabled;
    const isManagementEnabled = this.environmentService.environment.features?.management?.enabled;

    const isAdmin$: Observable<boolean> = this.oidcService.userData$.pipe(
      map((data) => data?.userData?.role === 'Admin' || data?.userData?.extension_Role === 'Admin')
    );

    return appMenus.map((menu) => {
      if (menu.routerLink === 'security') {
        menu.hidden = isAdmin$.pipe(map((isAdmin) => !(isSecurityEnabled && isAdmin)));
      } else if (menu.routerLink === 'management') {
        menu.hidden = isAdmin$.pipe(map((isAdmin) => !(isManagementEnabled && isAdmin)));
      } else {
        menu.hidden = of(false);
      }

      return menu;
    });
  }
}
